/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewWappalyzerAggregatedData
 */
export interface CRSFSecReviewWappalyzerAggregatedData {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewWappalyzerAggregatedData
     */
    categories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWappalyzerAggregatedData
     */
    cpe?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewWappalyzerAggregatedData
     */
    cves: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewWappalyzerAggregatedData
     */
    found: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWappalyzerAggregatedData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWappalyzerAggregatedData
     */
    version?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewWappalyzerAggregatedData interface.
 */
export function instanceOfCRSFSecReviewWappalyzerAggregatedData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "categories" in value;
    isInstance = isInstance && "cves" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CRSFSecReviewWappalyzerAggregatedDataFromJSON(json: any): CRSFSecReviewWappalyzerAggregatedData {
    return CRSFSecReviewWappalyzerAggregatedDataFromJSONTyped(json, false);
}

export function CRSFSecReviewWappalyzerAggregatedDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewWappalyzerAggregatedData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categories': json['categories'],
        'cpe': !exists(json, 'cpe') ? undefined : json['cpe'],
        'cves': json['cves'],
        'found': json['found'],
        'name': json['name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function CRSFSecReviewWappalyzerAggregatedDataToJSON(value?: CRSFSecReviewWappalyzerAggregatedData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categories': value.categories,
        'cpe': value.cpe,
        'cves': value.cves,
        'found': value.found,
        'name': value.name,
        'version': value.version,
    };
}

